
export class Launches {

    label: string;
    value: string;

    constructor() {
        this.label = "";
        this.value =  "";
    }

}

